import React from "react";
import "./Design/privacy.css";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-container-bg cookie-container">
        <div className=" container">
          <div className="row">
            <div className="col-xxl-7 col-lg-7 col-md-8 col-12">
              <div className="about-us">
                <h2 className="about-us-heading">Privacy Policy</h2>

                <p className="description">
                  Arab Gift Card places a strong emphasis on safeguarding the
                  confidentiality of your personal information. By accepting
                  this Privacy Policy, you explicitly grant us permission to
                  collect, utilize, and disclose your personal information
                  exclusively in accordance with the guidelines established in
                  this Privacy Policy. It is important to note that Arab Gift
                  Card does not engage in the sale, rental, or licensing of your
                  personal information to any third parties. 
                </p>

                <h4 className="sub-heading">
                  Arab Gift Card's Gathering of Personal Information 
                </h4>
                <p className="description">
                  In order to register for your Arab Gift Card Account, we
                  require specific personal information from you. It is
                  essential that you complete Arab Gift Card's registration form
                  accurately with authentic details, refraining from providing
                  any false or deceptive information. 
                </p>

                <div className="cokkie-content-section">
                  <h4 className="sub-heading">
                    Personal Information We Gather 
                  </h4>
                  <p className="description d-flex justify-content-between align-items-center">
                    <span className="dis-number">1</span>
                    <span className="discrption-inner">
                      Full Name, address, email, phone number, and any other
                      necessary details.
                    </span>
                  </p>
                  <p className="description d-flex justify-content-between align-items-center">
                    <span className="dis-number">2</span>
                    <span className="discrption-inner">
                      Financial information, such as credit/debit card or bank
                      account details, for optional transactions 
                    </span>
                  </p>

                  <p className="description">
                    Please be aware that failure to supply such information may
                    result in limitations on the usage of Arab Gift Card
                    services or the suspension of your Account. For high-value
                    transactions, we may have an obligation to report personal
                    information to the relevant authorities. 
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h4 className="sub-heading">Security Measures </h4>

              <p className="description">
                Once your registration is completed, you can begin using Arab
                Gift Card's services, which are rigorously protected against
                fraudulent activities and misuse through the following measures
                we implement: 
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">1</span>
                <span className="discrption-inner">
                  Recording and retaining your IP address and login times. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">2</span>
                <span className="discrption-inner">
                  Collecting usage and access data that enables us to thwart
                  multiple account creations, identify fraudulent behaviors, and
                  safeguard our systems against unlawful attacks or misuse. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">3</span>
                <span className="discrption-inner">
                  We may share such data with specialized and reputable fraud
                  management services that aid in data analysis. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">4</span>
                <span className="discrption-inner">
                  We employ cookies, which are small text files stored on a
                  user's computer for record-keeping purposes. Information
                  gathered and stored through cookies may be compared against
                  the personal data held on our systems. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">5</span>
                <span className="discrption-inner">
                  Depending on the information you have provided, your current
                  verification status, and the type of transaction you intend to
                  conduct, we may acquire further information from banks,
                  credit/debit card processing services, and identity
                  verification services. 
                </span>
              </p>

              <p className="description">
                We obtain your personal and security information from various
                sources, including: 
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">1</span>
                <span className="discrption-inner">
                  Information entered online, which may be retained even if you
                  do not finalize or submit an application. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">2</span>
                <span className="discrption-inner">
                  Information from third parties, utilized for identity
                  verification or fraud prevention. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">3</span>
                <span className="discrption-inner">
                  Information from third parties authorized by you to provide us
                  with information. 
                </span>
              </p>

              <p className="description d-flex justify-content-between align-items-center">
                <span className="dis-number">4</span>
                <span className="discrption-inner">
                  Information regarding your account experience and history. 
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
